var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-ueditor-wrap',{attrs:{"config":_vm.editorConfig,"editor-dependencies":_vm.editorDependencies},model:{value:(_vm.ueContent),callback:function ($$v) {_vm.ueContent=$$v},expression:"ueContent"}})}
var staticRenderFns = []

export { render, staticRenderFns }